export const WARNING_GELATO_PLUS_DAYS_LEFT = 7;
export const GELATO_PLUS_ONE_MONTH_LEFT_DAYS = 30;
